/*
 * API用の便利関数
 * TODO fujita repositoryに依存しているものは../Repositoryにあった方がいいが、呼び出し元の修正がたくさんある・・・
 */
import { errors as lang_error } from '@/lang/ja_JP'
import repoUtils from '../repositories/utils/Common'

// IE,Edge対策
// https://developer.mozilla.org/ja/docs/Web/API/FormData#Browser_compatibility
// require('formdata-polyfill')

// IE対策
// [ref] https://github.com/axios/axios#browser
// if (typeof URLSearchParams !== 'function') {
//   window.URLSearchParams = require('url-search-params')
// }
// window.qs = require('qs')

// IE対策 closest
// [ref] https://stackoverflow.com/a/35294561
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector
}
if (!Element.prototype.closest) {
  Element.prototype.closest = function (selector) {
    var el = this
    while (el) {
      if (el.matches(selector)) {
        return el
      }
      el = el.parentElement
    }
  }
}

export default {
  // data () {
  //   return {
  //     /**
  //      * APIで使ったsourceをためておくところ（キャンセル用）
  //      */
  //     apiSources: []
  //   }
  // },
  // beforeDestroy () {
  //   for (let source of this.apiSources) {
  //     repoUtils.httpCancel(source)
  //   }
  // },
  methods: {
    isApiSuccess: function (response) {
      return response.data && response.data.success
    },
    getApiData: function (response) {
      return response.data
    },
    isErrorNotFound: function (error) {
      const status = error.response && error.response.status
      return status === 404
    },
    _setErrorMessage: function (value, key) {
      let _errors = ('modalErrors' in this) ? this.modalErrors : this.errors
      if (this.$store.getState('debug')) {
        _errors.push((key ? '[' + key + '] ' : '') + value)
      }
      else {
        _errors.push(value)
      }
    },
    setErrorMessage: function (error) {
      this.clearErrorMessages()
      const errorMessage = this.getErrorMessage(error)
      if (errorMessage !== null) {
        this._setErrorMessage(errorMessage)
      }
    },
    /**
     * エラーメッセージを抜き出したり整形したりして返す
     * @param error
     * @returns {string|null}
     * @retval {string} エラーメッセージ
     * @retval {null} 文字列で返すのが難しいからセットしちゃいました。何もしなくていいです。
     */
    getErrorMessage: function (error) {
      // JSエラー、サーバー停止など
      if (!error.response) {
        // APIキャンセルは除外
        if (repoUtils.isApiCanceled(error)) {
          return null
        }
        // タイムアウトエラー
        else if (this.isTimeoutError(error)) {
          return lang_error.timeout
        }
        // ネットワークエラー
        else if (this.isNetworkError(error)) {
          return lang_error.networkError
        }
        return error.message
      }

      let status = error.response && error.response.status
      let data = error.response && error.response.data
      let key, type
      // mockファイルが404
      if (data === undefined) {
        return error.message || 'Unknown Error'
      // システムエラー
      }
      else if (status === 500) {
        return 'システムエラーが発生しました。管理者にお問い合わせください。' +
          data.data.message
      // バリデーションエラー
      }
      else if (status === 422) {
        this._setValidationErrorMessages(data.data.errors)
        return null
      // アプリエラー
      }
      else if (data.data) {
        if ('errors' in data.data) {
          for (key in data.data.errors) {
            for (type in data.data.errors[key]) {
              this._setErrorMessage(data.data.errors[key][type], key)
              return null
            }
          }
        }
        else {
          return data.data.message
        }
      // システムエラー
      }
      else {
        return data.message
      }
    },
    /**
     * 再起関数：arrayとpbjectが混在しているEntityエラーを配列に直す
     */
    _setValidationErrorMessages: function (errors) {
      // Stringになったら終了
      if (typeof errors === 'string') {
        this._setErrorMessage(errors)
      }
      // Array
      else if (Array.isArray(errors)) {
        for (let i = 0, len = errors.length; i < len; i++) {
          this._setValidationErrorMessages(errors[i])
        }
      }
      // Object
      else {
        for (let i in errors) {
          this._setValidationErrorMessages(errors[i])
        }
      }
    },
    setSuccessMessage: function (success) {
      if (typeof success === 'string') {
        this.successes.push(success)
      }
      else {
        this.successes = ['処理が成功しました。']
      }
    },
    isTimeoutError: function (error) {
      return error.code === 'ECONNABORTED'
    },
    isNetworkError: function (error) {
      const message = error.message
      return (message && message.toLowerCase().indexOf('network error') === 0)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/api.js